import { JobStatus } from '../lib/Jobs';
class BuildMetadata {
    constructor() {
        this.buildStartTime = new Date().toISOString();
    }
    static setJobStatusToFailed() {
        const instance = BuildMetadata.getInstance();
        instance.status = JobStatus.FAILED;
    }
    static setJobStatusToSuccess() {
        const instance = BuildMetadata.getInstance();
        instance.status = JobStatus.SUCCESS;
    }
    static setSuccessRoutes(routes) {
        const instance = BuildMetadata.getInstance();
        instance.successRoutes = routes;
    }
    static setFailedRoutes(routes) {
        const instance = BuildMetadata.getInstance();
        instance.failedRoutes = routes;
    }
    static setMsg(msg) {
        const instance = BuildMetadata.getInstance();
        instance.msg = msg;
    }
    static updateSanityQueriesCount(count) {
        const instance = BuildMetadata.getInstance();
        instance.sanityQueriesCount = count;
    }
    static updateSanityQueriesHitCacheCount(count) {
        const instance = BuildMetadata.getInstance();
        instance.sanityQueriesHitCacheCount = count;
    }
    static addSlowQuery(query) {
        var _a;
        const instance = BuildMetadata.getInstance();
        (_a = instance.slowQueries) !== null && _a !== void 0 ? _a : (instance.slowQueries = []);
        instance.slowQueries.push(query);
    }
    static updateMemoryUsage(usage) {
        const instance = BuildMetadata.getInstance();
        const prettifiedUsage = usage;
        Object.entries(usage).forEach(([key, value]) => {
            prettifiedUsage[key] = formatMemoryUsage(Number(value));
        });
        instance.memUsage = prettifiedUsage;
    }
    static getInstance() {
        var _a;
        (_a = BuildMetadata.instance) !== null && _a !== void 0 ? _a : (BuildMetadata.instance = new BuildMetadata());
        return BuildMetadata.instance;
    }
}
BuildMetadata.metadataPath = ['.nuxt', 'build-metadata.json'];
BuildMetadata.instance = null;
const formatMemoryUsage = (num) => {
    let power = 0;
    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    while (num >= 1024 && power < units.length - 1) {
        num /= 1024;
        power++;
    }
    return `${num.toFixed(2)} ${units[power]}`;
};
export default BuildMetadata;
